import { props } from './syllabus-block-utils';
import Block from './block';

export default {
  template: '#title-block-template',
  props,
  data() {
    return Object.assign({
      title: '',
      content: '',
      showOnPublicSyllabus: true,
      //
      // TODO: Quill?
      //
      redactorOptions: {
        buttonsHide: ['unorderedlist', 'orderedlist', 'outdent', 'indent', 'formatting', 'alignment', 'html', 'horizontalrule']
      }
    }, this.rootData);
  },
  components: {
    Block
  },
  watch: {
    dataForSave() {
      this.$emit('block-update', this.dataForSave);
    },
  },
  computed: {
    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          content: this.content,
          showOnPublicSyllabus: this.showOnPublicSyllabus
        }
      };
    },
    isEmpty() {
      return _.isEmpty(s.stripTags(this.content));
    }
  },
};
